import { typeMessageHandlerFunction } from '@/Services/Firebase';
import { firebase_instance } from "@/Services/Firebase";
import { useEffect } from "react";


const camelToSnakeCase = (str: string) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);


export function useOnFirebaseMessage(handler: typeMessageHandlerFunction) {

  useEffect(() => {
    const index = firebase_instance.subscribeMessageHandler(handler);

    return () => firebase_instance.unSubscribeMessageHandler(index);
  }, [handler]);
}

